import BaggageList from './components/BaggageList.css';
import BaggageCount from './components/BaggageCount/BaggageCount.css';
import BaggageDirection from './components/BaggageDirection/BaggageDirection.css';

export default {
	BaggageList,
	BaggageCount,
	BaggageDirection
};
